export function AccessLevels() {
    return [
        {
            name: 'Client',
            value: 'client',
        },
        {
            name: 'User',
            value: 'user',
        }
    ];
}